import { leaguePhaseReloader, matchesUpdates } from '../../../build/featureCollections/features';

/**
 * Načtení seznamu zápasů s tabulkou pro fáze
 * Např. liga: MS v hokeji, fáze: Skupina A, Skupina B, Play-off
 *
 * @param {HTMLElement} wrapper HTML element obsahující seznam zápasů ligové fáze, která se má aktualizovat.
 * @return {void}
 */
export const initMatchesWithTablePhaseReloader = (wrapper: HTMLElement): void => {
  if (!wrapper) {
    return;
  }

  const MatchesWithTableElement: HTMLElement | null = wrapper.querySelector(
    '[data-matches-with-table-phase-reloader]'
  );

  const phaseId = MatchesWithTableElement && MatchesWithTableElement.getAttribute('data-phase-id');

  const reloadBoxId =
    MatchesWithTableElement &&
    MatchesWithTableElement.getAttribute('data-matches-with-table-phase-reloader');

  const buttonList: NodeListOf<HTMLButtonElement> | null = wrapper.querySelectorAll(
    '[data-chip-menu-item-id]'
  );

  if (!buttonList || !MatchesWithTableElement || !reloadBoxId) {
    console.warn(
      `Elementy [data-phase-id] a element ['data-matches-with-table-phase-reloader'] nebyly nalezeny.`
    );
    return;
  }

  const phaseLoader: HTMLSpanElement | null = wrapper.querySelector('[data-tabs-chip-menu-loader]');

  /**
   * Nastavení aktivní třídy při prvním načtení
   */
  buttonList.forEach((button) => {
    const btnPhaseId = button.getAttribute('data-chip-menu-item-id');
    if (btnPhaseId === phaseId) {
      button.classList.add('sportmod-tabs-chip-menu__chip-active');
    }
  });

  /**
   * Kliknutí na button podligy
   */
  buttonList.forEach(function (button) {
    button.addEventListener('click', function () {
      const phaseId = button.getAttribute('data-chip-menu-item-id');

      // Nastavi se aktivní třída pouze na aktuální button
      buttonList.forEach((btn) => {
        btn.classList.toggle('sportmod-tabs-chip-menu__chip-active', btn === button);
      });

      const url = `?_sobfr=${reloadBoxId}&phase=${phaseId}&action=phase&ajax`;

      if (phaseLoader) {
        // Zobrazení preloaderu
        phaseLoader.style.display = 'inline-flex';
      }

      fetch(url, {
        method: 'GET',
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Chyba při načítání dat');
          }
          return response.text();
        })
        .then(async (data) => {
          MatchesWithTableElement.innerHTML = data;

          // Nastavi se pro donačtené zápasy update přes web sokety.
          await matchesUpdates();

          // Nastavi se pro donačtené zápasy update fáze - dropdown menu fáze.
          await leaguePhaseReloader();
        })
        .catch(() => {
          MatchesWithTableElement.innerHTML = '<p>Data se nepodařilo načíst</p>';
        })
        .finally(() => {
          // Skrytí preloaderu
          if (phaseLoader) {
            phaseLoader.style.display = 'none';
          }
        });
    });
  });
};
